import store from "../../repository/store/store";

/** Displays a loading screen while the callback is running.
 * @param callback function that will be running while the loading screen is visible.
 * @param message message that will display on the loading box. It is optional and defaults to "Carregando..." */
export async function wrapLoading<T>(
  callback: () => Promise<T>,
  message?: string
): Promise<T> {
  await store.dispatch("loading_module/setLoadingMessage", message);
  await store.dispatch("loading_module/setLoadingVisibility", true);
  try {
    return await callback();
  } finally {
    await store.dispatch("loading_module/setLoadingVisibility", false);
  }
}

/** Displays a loading screen while the callback is running.
 * @param callback function that will be running while the loading screen is visible.
 * @param message message that will display on the loading box. It is optional and defaults to "Carregando..." */
export async function wrapContentLoading(
  callback: () => Promise<void>,
  message?: string
): Promise<void> {
  await store.dispatch("utils_module/setContentLoadingMessage", message);
  await store.dispatch("utils_module/setContentLoadingVisibility", true);
  try {
    await callback();
  } finally {
    await store.dispatch("utils_module/setContentLoadingVisibility", false);
  }
}
